import { sendCustomEvent } from '../../scripts/config/analytics';

export const initCopyDiscountCode = () => {
  const promoBtnSelector = 'data-discount-code-promo-btn';
  const promoBtns = document.querySelectorAll(`[${promoBtnSelector}]`);

  promoBtns.forEach((promoBtn) => {
    promoBtn.addEventListener('click', (event) => {
      const promoCode = event.currentTarget.getAttribute(`${promoBtnSelector}`);

      navigator.clipboard.writeText(promoCode).then(
        () => {
          promoBtn.setAttribute('data-result', 'success');
          setTimeout(() => promoBtn.removeAttribute('data-result'), 1500);
          sendCustomEvent({
            category: 'Discount Code',
            action: 'Button Click',
            label: promoCode,
          });
        },
        () => {
          promoBtn.setAttribute('data-result', 'fail');
          setTimeout(() => promoBtn.removeAttribute('data-result'), 1500);
        }
      );
    });
  });
};
